import { jsx as _jsx } from "react/jsx-runtime";
import { getCensorRatingById } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useFilmContext } from '../../../context/film/hooks/use-film-context';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
const b = bemClassBuilder('v-film-classification-description');
export const FilmClassificationDescription = observer(() => {
    const i18n = useI18n();
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { film } = useFilmContext();
    if (!film) {
        return enableSkeletonLoadingIndicators ? _jsx(FilmClassificationDescriptionSkeleton, {}) : null;
    }
    const censorRating = film.censorRatingId ? getCensorRatingById(film.censorRatingId) : undefined;
    const classificationNote = i18n.translatable(censorRating.classification) // Hack - replacing classification note with classification
    // const classificationNote = film.censorRatingNote
    //     ? i18n.translatable(film.censorRatingNote)
    //     : i18n.translatable(censorRating === null || censorRating === void 0 ? void 0 : censorRating.classificationDescription);
    // if (!classificationNote)
    //     return null;
    return _jsx("span", Object.assign({ className: b.block() }, { children: classificationNote }));
});
FilmClassificationDescription.displayName = 'FilmClassificationDescription';
export const FilmClassificationDescriptionSkeleton = () => _jsx("div", { className: b.block({ skeleton: true }) });
FilmClassificationDescriptionSkeleton.displayName = 'FilmClassificationDescriptionSkeleton';
/**
 * The **Film Classification Description** component renders a film's censor rating classification description.
 */
export const FilmClassificationDescriptionComponent = withComponentWrapper(FilmClassificationDescription, {}, () => true);
